import React from "react";
import "./backbutton.css";
import { useNavigate } from "react-router-dom";

/**
 * DynamicBackButton
 * - Automatically checks if user is signed in:
 *   ✅ If signed in → goes back or redirects to `/dashboard`
 *   ❌ If not signed in → redirects to `/login`
 *
 * Props:
 *  - to: string fallback URL
 *  - navigate: optional navigate() from react-router
 *  - replace: whether to use replace instead of push
 *  - label, className, icon, confirmMessage same as before
 */
export default function DynamicBackButton({
  to = "/",
  // navigate = null,
  onNavigate = () => {},
  label = "Back",
  className = "",
  icon = null,
  confirmMessage = "",
  replace = false,
  ariaLabel = "Go back",
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();

    if (confirmMessage && !window.confirm(confirmMessage)) return;

    // const canGoBack =
    //   typeof window !== "undefined" &&
    //   window.history &&
    //   window.history.length > 1;

    // ✅ Check if user is logged in
    const user = JSON.parse(localStorage.getItem("user") || "null");
    const token = localStorage.getItem("token");
    const isSignedIn = !!(user && token);

    // ✅ Determine destination
    const fallbackUrl = isSignedIn ? "/dashboard" : "/login";

    // ✅ Prefer react-router navigate if passed
    if (navigate && typeof navigate === "function") {
      /* if (canGoBack) {
         try {
           window.history.back();
           onNavigate({ method: "back" });
           return;
         } catch (err) {
           // fallback to navigate
         }
       } */

      const destination = fallbackUrl;
      navigate(destination, { replace: true });
      // onNavigate({ method: "navigate", to: destination });
      return;
    }

    // Final fallback: direct URL redirect
    const destination = fallbackUrl;
    window.location.href = destination;
    onNavigate({ method: "navigate", to: destination });
  };

  return (
    <div className="back-action">
      <button
        type="button"
        onClick={handleClick}
        aria-label={ariaLabel}
        className={`back-btn theme-clr ${className}`}
      >
        {icon || (
          <svg
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 13L1 7L7 1"
              stroke="#091DF2"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {label}
      </button>
    </div>
  );
}
